var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://govuk-elements.herokuapp.com/alpha-beta-banners/
import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { BLUE, WHITE } from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledBadge = styled('strong')((_styled = {
  display: 'inline-block',
  margin: '0 8px 0 0',
  padding: '2px 5px',
  fontFamily: NTA_LIGHT,
  fontWeight: 700,
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  textDecoration: 'none',
  color: WHITE,
  backgroundColor: BLUE,
  WebkitFontMmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16,
  paddingBottom: 0
}, _styled));

var PhaseBadge = function PhaseBadge(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return React.createElement(StyledBadge, _extends({
    className: className
  }, props));
};

PhaseBadge.defaultProps = {
  className: undefined
};
PhaseBadge.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(PhaseBadge);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/phase-badge/es/index.js
// module id = 27
// module chunks = 0